import React from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "./Navbar";
import NavbarStudents from "../Dashboard/Navbarlogedin";
import NavbarProfessionals from "../Interviewer/NavbarInterviewer";
import "./Navbar.css";
import Footer from "./Footer";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

const Contact = () => {
  const user = JSON.parse(localStorage.getItem("isIAuthenticated"));
  const navigate = useNavigate();
  return (
    <>
      <div className="relative h-screen w-full" id="contact-us-container">
        {!user?.role ? <Navbar /> : null}
        {user?.role === "Student" ? <NavbarStudents /> : null}
        {user?.role === "Interviewer" ? <NavbarProfessionals /> : null}
        <div className="absolute" id="contact-us-cover"></div>
        <div
          className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white flex justify-between items-center p-8 rounded-lg gap-8"
          id="contact-us"
        >
          <div
            className="absolute h-16 w-16 rounded-l-lg right-0 bottom-10 flex justify-center cursor-pointer"
            id="linkedin-icon"
          >
            <a href="https://www.linkedin.com/company/fyzen-career-solutions/">
              <i class="fa-brands fa-linkedin-in text-3xl text-white"></i>
            </a>
          </div>
          <div className="w-full">
            <Typography
              variant="h4"
              component="h4"
              sx={{ color: "#676df5", fontWeight: "bold" }}
              gutterBottom
            >
              Get In Touch
            </Typography>
            <Typography
              variant="subtitle1"
              sx={{ color: "#a9a9a9", fontWeight: "bold" }}
              gutterBottom
            >
              We are here! How can we help you?
            </Typography>
            <TextField
              id="name"
              label="Name"
              placeholder="Please Enter Your Name"
              type="text"
              sx={{ width: 1, my: 1 }}
            />
            <TextField
              id="email"
              label="Email"
              placeholder="Please Enter Your Email"
              type="email"
              sx={{ width: 1, my: 1 }}
            />
            <TextField
              id="comment"
              label="Comment"
              placeholder="Write you comment..."
              multiline
              rows={4}
              maxRows={4}
              sx={{ width: 1, my: 1 }}
            />
            <Button
              variant="contained"
              sx={{
                width: 1,
                py: 1,
                backgroundColor: "#676df5",
                fontSize: 16,
                fontWeight: "bold",
              }}
            >
              Sumbit
            </Button>
          </div>
          <div className="w-full">
            <div className="flex justify-center">
              <img
                src={require("../../images/contact-us-image.jpg")}
                style={{ height: "150px" }}
                alt="Contact Us"
              />
            </div>
            <div className="flex gap-3 my-2">
              <div className="flex items-center">
                <div
                  className="h-12 w-12 border border-black rounded-full flex justify-center text-xl"
                  style={{ color: "#676df5" }}
                >
                  <i class="fa-sharp fa-solid fa-location-dot"></i>
                </div>
              </div>
              <div className="">
                <Typography
                  variant="subtitle2"
                  sx={{ color: "gray" }}
                  gutterBottom
                >
                  Registered Address
                </Typography>
                <Typography variant="body1" gutterBottom>
                  Fyzen Career Solutions Private Limited, 090/LT-1 (B), Tambri
                  Osmanabad, Maharashtra – 413501, India.
                </Typography>
                <Typography
                  variant="subtitle2"
                  sx={{ color: "gray" }}
                  gutterBottom
                >
                  Correspondence Address
                </Typography>
                <Typography variant="body1" gutterBottom>
                  Utsav Bhardwaj, Indian Institute of Technology Delhi, New
                  Delhi, Delhi – 110016, India.
                </Typography>
              </div>
            </div>
            <div className="flex gap-3 my-2">
              <div className="flex items-center">
                <div
                  className="h-12 w-12 border border-black rounded-full flex justify-center text-xl"
                  style={{ color: "#676df5" }}
                >
                  <i class="fa-solid fa-phone"></i>
                </div>
              </div>
              <div className="">
                <Typography variant="body1" gutterBottom>
                  +91-9176583479
                </Typography>
              </div>
            </div>
            <div className="flex gap-3 my-2">
              <div className="flex items-center">
                <div
                  className="h-12 w-12 border border-black rounded-full flex justify-center text-xl"
                  style={{ color: "#676df5" }}
                >
                  <i class="fa-solid fa-envelope"></i>
                </div>
              </div>
              <div className="">
                <Typography variant="body1" gutterBottom>
                  support@interwiu.com
                </Typography>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Contact;
